/**
 * useSocialLogoSets — active social logo sets for the DnD email editor's
 * social blocks (via api-v5 `GET /social-logo-sets`).
 *
 * Cached account-wide so selecting a set in any social block reuses one fetch.
 */
import { useQuery } from '@tanstack/react-query';
import { listSocialLogoSets, type SocialLogoSet } from '@/services/socialLogoSets.service';
import { useAuthStore } from '@/store/authStore';

export function useSocialLogoSets() {
  const accountId = useAuthStore((s) => s.accountId);

  return useQuery<SocialLogoSet[]>({
    queryKey: ['social-logo-sets', accountId],
    queryFn: listSocialLogoSets,
    enabled: !!accountId,
    staleTime: 5 * 60_000,
    retry: false,
  });
}
